module.exports = __webpack_public_path__ + "img/A_0-4ABD-PL_1_530.3c743af6.png";